import "core-js/modules/esnext.global-this.js";
import { getTmsInstance } from "integration-web-core--socle/js/assets/commons/_tms";
export function pushTrackingEvent(eventName, eventData) {
  getTmsInstance().pushEvent(globalThis, 'cdl_event', {
    event_name: eventName,
    event_data: eventData
  });
}